import { StateController, autoplay, delay, dispatcher, platform, serverData } from "@aceroll/core";
import { POPUP_AUTO_PROCEED_TIME } from "../constants";
import { sounds } from '../services';

class FeatureEnterController extends StateController {
    constructor() {
        super("feature.enter");
        this.featureName;
        this.app = dispatcher.app;
    }

    async onStart() {
        platform.setFeatureTotalWin('0');
        this.featureName = serverData.currentResponse.bonusFeatureWon.name;
        serverData.currentResponse.bonusFeatureWon = [];

        serverData.currentFeature = this.featureName;

        console.log('featureEnter', serverData);
        console.log(serverData.nextResponses)

        sounds.fadeOutCurrentAmbient(1000);

        platform.setFeatureEnter(this.featureName);
        await this.app.layout.featurePopup.show(serverData.featureCount[this.featureName], this.featureName);
        this.app.layout.setBonusGameLayout();

        sounds.setBonusSplashAmbient(500);

        if (this.featureName === 'bonus_2') { // show panel at start of the bonus_2
            this.app.layout.multiplierPanel.showBonus(1, this.featureName !== 'bonus_1');
        }

        if (!autoplay.isStarted() || autoplay.isStopNeededOnFeature()) {
            await platform.onceClickScreen();
        } else {
            await Promise.race([
                delay(POPUP_AUTO_PROCEED_TIME),
                platform.onceClickScreen()
            ]);
        }

        sounds.fadeOutCurrentAmbient(1000);
        sounds.setBonusAmbient(1500);

        await this.app.layout.featurePopup.hide();

        serverData.setCurrentResponse();
        this.stop();
    }

    onStop() {

    }
}

export default FeatureEnterController;